import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AccountReceivableReportService {
  private url = environment.api;

  constructor(
    private http: HttpClient,
  ) { }

  getBillReceivableGeneralBalanceReport(date: number, type: string, warehouseId = 0) {
    return this.http.get(this.url + "api/erp/bill/reports/rec1/" + type, {
      params: {
        date: date,
        warehouseId: warehouseId
      }
    });
  }

  getBillToReceivableList(type: string) {
    return this.http.get(this.url + "api/erp/bill/reports/list/" + type, {
      params: {
        cxp: false
      }
    });
  }

  getBillReceivableRecurrence(startDate:number, endDate:number, recurrenceId:number, type: string) {
    return this.http.get(this.url + "api/erp/bill/reports/recurrence/" + type, {
      params: {
        date: startDate,
        endDate: endDate,
        recurrenceId: recurrenceId
      }
    });
  }

  getIntegratedRecurrence(startDate:number, endDate:number, type: string) {
    return this.http.get(this.url + "api/erp/bill/reports/integrationRecurrence/"+startDate+"/"+endDate +"/"+ type);
  }

  

  getCXCReport(type: string, warehouseId: number | null) {

    let params = new HttpParams();

    if (warehouseId !== null) {
        params = params.set('warehouse', warehouseId.toString());
    }
    
    return this.http.get(this.url + "api/erp/bill/reports/cxc/"+type, {params});
  }
}
